var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.personalizedType !== 'clipartCategory')?_c('FormulateInput',{attrs:{"name":_vm.layer.id,"label":_vm.label,"width":_vm.width,"height":_vm.height,"rotation":_vm.rotation,"layer":_vm.layer,"x":_vm.x,"y":_vm.y,"type":"imagecutface","aspectRatio":_vm.aspectRatio}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24b01c78","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Form/ImageCutFaceField.vue
// module id = 227
// module chunks = 0